<!--    Side menu-->
<ng-container *transloco="let t">
  <nav [ngClass]="{'mobile-menu-visible': isMobileMenuActive}" class="sidebar" (mouseenter)="onSidebarHover(true)"
       (mouseleave)="onSidebarHover(false)">
    <div class="admin-logo-wrapper align-items-center">
      <img src="assets/img/svg/tracey-logo-white.svg" alt="Tracey logo" class="admin-logo-img"
           (click)="onClickToLogoImage()">
    </div>
    <div class="vertical-menu">
      <ul>
        @for (menuItem of items;track menuItem) {
          <li (click)="menuItemClicked(menuItem.navigationRoute, menuItem.navigationQueryParams)"
              [class.active]="menuItem.isActive">
            <div class="icon-box">
              <i [class]="menuItem.icon"></i>
            </div>
            <span class="text-nowrap">{{t(menuItem.labelKey)}}</span>
            @if (menuItem.key === AdminMenuItem.LIST_OF_REQUESTS && (numberOfRequests ?? 0) > 0) {
              <div class="unread-msg-circle ms-auto">
                {{numberOfRequests}}
              </div>
            }
          </li>
        }
      </ul>
      <ul>
        <li (click)="goToUserModule()">
          <div class="icon-box">
            <i class="fas fa-user"></i>
          </div>
          <span>{{t('app.common.competitor')}}</span>
        </li>
        <hr class="vertical-separator">
        <li (click)="logout()">
          <div class="icon-box">
            <i class="fa fa-sign-out-alt"></i>
          </div>
          <span>{{t('app.common.logout')}}</span>
        </li>
      </ul>
    </div>
  </nav>
</ng-container>
